"use client";

import React from "react";
import s from "../styles";

/**
 * メッセージコンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Object} props.form - フォームオブジェクト
 * @param {Object} props.formProps - フォームプロパティ
 * @param {string} props.mode - "view"（参照モード）または"edit"（編集モード）
 * @param {Object} props.data - データオブジェクト（data?.SessionData?.Informationから値を取得）
 * @returns {JSX.Element} メッセージコンポーネント
 */
export default function MessageArea({ form, formProps, mode = "edit" }) {
  const isViewMode = mode === "view";

  // 参照モードの場合 background: #FFF;
  if (isViewMode) {
    return (
      <s.OrderInfoTable>
        <tbody>
          <tr>
            <s.OrderInfoRight width="200" scope="row" style={{ backgroundColor: "#ffbcbc" }}>
              メッセージ
              <br />
              <s.SmallFont>(見積に際しての備考等をご入力下さい。お客様の画面へ表示されます。)</s.SmallFont>
            </s.OrderInfoRight>
            <s.OrderInfoNote scope="row" style={{ backgroundColor: "#fff" }}>
              <div style={{ width: "100%", whiteSpace: "pre-line" }}>{form?.Bikou}</div>
            </s.OrderInfoNote>
          </tr>
        </tbody>
      </s.OrderInfoTable>
    );
  }

  // 編集モードの場合
  return (
    <s.OrderInfoTable>
      <tbody>
        <tr>
          <s.OrderInfoRight width="200" scope="row" style={{ backgroundColor: "#ffbcbc" }}>
            メッセージ
            <br />
            <s.SmallFont>(見積に際しての備考等をご入力下さい。お客様の画面へ表示されます。)</s.SmallFont>
          </s.OrderInfoRight>
          <s.OrderInfoNote scope="row" style={{ backgroundColor: "#fff" }}>
            {formProps.input_Bikou({ style: { width: "100%" } })}
          </s.OrderInfoNote>
        </tr>
      </tbody>
    </s.OrderInfoTable>
  );
}
